import { render, staticRenderFns } from "./EditGoodsContents.vue?vue&type=template&id=33310966&scoped=true"
import script from "./EditGoodsContents.vue?vue&type=script&lang=js"
export * from "./EditGoodsContents.vue?vue&type=script&lang=js"
import style0 from "./EditGoodsContents.vue?vue&type=style&index=0&id=33310966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33310966",
  null
  
)

export default component.exports